import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";

export const CUPS_PRICE_LEVEL_CONSTANTS = {
  PAGE_TITLE_SEARCH: "Nivel de precio",
  PAGE_TITLE_CREATE: "Agregar nivel de precio",
  PAGE_TITLE_CLIENT: "Agregar cliente",
  PAGE_TITLE_EDIT_CLIENT: "Editar cliente",
  PAGE_TITLE_EDIT: "Editar nivel de precio",
  LABEL: {
    NAME: "Nombre*",
    URL_CUPS: "Cups*",
    PRICE: "Precio*",
    CLIENT: "Clientes*"
  },
  BUTTON: {
    ADD_CUPS_PRICE: "Crear Nivel de precio",
    ADD_CLIENTS: "Agregar clientes",
    UPDATE_CLIENT: "Actualizar cliente"
  },
  DELETE_MODAL: {
    TITLE: "Eliminar nivel de precio",
    TEXT: "Ingrese la razón por la cual va a deshabilitar el nivel de precio:"
  },
  MESSAGE: {
    MAX_LENGTH: "Máximo 50 caracteres",
    CUPS_EXISTS: "El CUPS ya existe",
    CLIENT_MIN: "Debe ingresar al menos un cliente",
    CUPS_PRICE_LEVEL_USED:
      "El nivel de precio está en uso, no se puede eliminar",
    CLIENT_REPEATED: "El cliente ya existe"
  },
  CUPS_INFO: {
    NAME: "Nombre: ",
    PRICE: "Precio: "
  },
  TOOLTIP_CANCEL: "Cancelar",
  GRAPHS: {
    STATE: "Nivel de precio por estado"
  },
  EMIT: {
    UPDATE: "update",
    EVENT_FORM_EDIT: "eventFormEdit",
    EVENT_SERVICE_CUPS: "eventServiceCups",
    CLOSE_ADD_CLIENT: "handleCloseAddClients",
    CLOSE_ADD_LIST: "handleCloseAddList"
  },
  CLIENTS_COMPONENT_ID: "addClientComponent",
  CLIENTS_COMPONENT_CONTAINER_ID: "addClientComponentContainer",
  ADD_CLIENTS_ID: "addClient",
  FALSE: "false",
  SCROLL: "scroll",
  SAVE_CUPS_ID: "cupsPriceLevelForm",
  LIST_CLIENTS_ID: "E1RF1BuRUwmVsR7OAJkp"
};

export const CUPS_VALIDATORS = {
  MAX_LENGTH: (v: string) =>
    v.length <= 50 || CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.MAX_LENGTH
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Nivel de precio",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE
  },
  {
    name: "Estado",
    placeholder: "Estado de Nivel de precio",
    key: "state",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const CUPS_FILTERS: Filter[] = [
  {
    mainFilterKey: "all",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS,
    initial: true,
    placeholder:
      "Escriba el nombre del nivel de precio o utiliza los filtros para agrupar información"
  }
];

export const CUPS_EVENTS = {
  CANCEL: "cupsCancel"
};

export const CUPS_ACCESS = {
  GET: "consultar niveles de precio",
  POST: "crear niveles de precio",
  PUT: "modificar niveles de precio",
  DELETE: "eliminar niveles de precio"
};
